import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { QueenPicker } from '../QueenPicker';
import { GoldBow } from '../GoldBow';
export function SuccessPanel({
  firstName
}: {
  firstName: string;
}) {
  const {
    t
  } = useLanguage();
  const reduce = useReducedMotion();
  return <div className="border border-camel/40 bg-white/[0.04] p-6 text-center sm:p-10" data-id="element-166" data-mp="1gfh19erw8v11">
      {/* The gold bow, not a generic check — it is the brand's delivery signature. */}
      <motion.div initial={reduce ? undefined : {
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-gold/50" data-id="element-167" data-mp="nrbhovcktc2s">
        <GoldBow className="h-7 w-9" data-id="element-168" data-mp="2e14ob92gm0zw" />
      </motion.div>

      <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-[0.06em] text-white sm:text-3xl" data-id="element-169" data-mp="293mpibi5p25m">
        {t('success.title', {
        name: firstName.toUpperCase()
      })}
      </h3>
      <p className="mx-auto mt-3 max-w-md text-base leading-relaxed text-white/70" data-id="element-170" data-mp="2shauid0usy9u">
        {t('success.sub')}
      </p>

      {/* No auto-redirect, no popup, no countdown — the visitor chooses and clicks. */}
      <div className="mt-8 text-left" data-id="element-171" data-mp="31hpg7dhqcfdv">
        <QueenPicker context="success-panel" tone="dark" data-id="element-172" data-mp="31go7vgs3m6zu" />
      </div>
    </div>;
}